var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyBurgoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 55,
    viewBox: "0 0 197 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8895 25.4016C30.9278 22.1322 28.2578 23.4945 27.168 24.5843C28.2578 22.6771 30.9278 18.5358 32.8895 17.228C34.8511 15.9203 38.8834 20.7071 40.2457 22.8867C44.169 30.7334 42.6978 41.7488 41.8804 46.653L33.7068 46.5901C36.9763 39.2339 35.3416 29.4884 32.8895 25.4016Z",
    fill: "url(#paint0_linear_3047_8368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.446 31.1238C16.2149 35.0471 11.9101 31.8783 10.8203 29.4262C12.455 31.0609 15.0706 32.2681 18.9939 23.7675C22.9172 15.267 23.8981 12.3245 27.9849 11.5071C35.3411 10.6898 38.3381 18.8006 40.2452 22.8874C32.0716 17.9832 30.4369 20.4981 27.1675 24.5849C24.5519 27.8543 23.6256 29.489 21.446 31.1238Z",
    fill: "url(#paint1_linear_3047_8368)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "url(#paint2_linear_3047_8368)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "#7D00B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "url(#paint3_linear_3047_8368)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "url(#paint4_linear_3047_8368)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint5_linear_3047_8368)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.73233,
    cy: 16.348,
    r: 3.26944,
    fill: "url(#paint6_linear_3047_8368)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.73233,
    cy: 16.348,
    r: 3.26944,
    fill: "url(#paint7_linear_3047_8368)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.73233,
    cy: 16.348,
    r: 3.26944,
    fill: "url(#paint8_linear_3047_8368)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint9_linear_3047_8368)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint10_linear_3047_8368)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint11_linear_3047_8368)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3047_8368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.811 35.9884C101.811 37.3041 101.559 38.5384 101.057 39.6914C100.554 40.8446 99.8668 41.8572 98.9946 42.7294C98.1372 43.5868 97.132 44.2667 95.9789 44.7695C94.8259 45.2721 93.5915 45.5233 92.2758 45.5233H76.377V13.7256H92.2758C93.5915 13.7256 94.8259 13.9769 95.9789 14.4795C97.132 14.9821 98.1372 15.6695 98.9946 16.5417C99.8668 17.3991 100.554 18.4043 101.057 19.5574C101.559 20.7104 101.811 21.9448 101.811 23.2605C101.811 23.8518 101.729 24.4579 101.567 25.0788C101.404 25.6996 101.175 26.2983 100.879 26.8749C100.584 27.4514 100.229 27.9762 99.815 28.4492C99.4011 28.9223 98.9429 29.314 98.4402 29.6245C98.9576 29.9053 99.4233 30.2897 99.8372 30.7775C100.251 31.2506 100.606 31.7753 100.902 32.3519C101.197 32.9284 101.419 33.5345 101.567 34.1701C101.729 34.791 101.811 35.3971 101.811 35.9884ZM82.7409 39.1593H92.2758C92.7193 39.1593 93.1332 39.078 93.5176 38.9153C93.9019 38.7529 94.2345 38.5312 94.5154 38.2501C94.8111 37.9546 95.0402 37.6145 95.2028 37.2302C95.3654 36.8458 95.4467 36.4319 95.4467 35.9884C95.4467 35.5449 95.3654 35.131 95.2028 34.7467C95.0402 34.3623 94.8111 34.0297 94.5154 33.7488C94.2345 33.4532 93.9019 33.224 93.5176 33.0614C93.1332 32.8988 92.7193 32.8175 92.2758 32.8175H82.7409V39.1593ZM82.7409 26.4535H92.2758C92.7193 26.4535 93.1332 26.3723 93.5176 26.2096C93.9019 26.047 94.2345 25.8253 94.5154 25.5444C94.8111 25.2488 95.0402 24.9088 95.2028 24.5244C95.3654 24.1253 95.4467 23.704 95.4467 23.2605C95.4467 22.817 95.3654 22.4031 95.2028 22.0187C95.0402 21.6344 94.8111 21.3017 94.5154 21.0209C94.2345 20.7252 93.9019 20.4961 93.5176 20.3335C93.1332 20.1709 92.7193 20.0896 92.2758 20.0896H82.7409V26.4535ZM107.693 23.3014C108.479 23.327 108.007 23.2937 109.193 23.3014C110.222 23.3014 110.15 23.3014 111.03 23.3014V34.5335C111.03 35.2298 111.166 35.8958 111.439 36.5316C111.711 37.1371 112.075 37.6669 112.529 38.1211C112.983 38.5752 113.513 38.9386 114.118 39.2109C114.754 39.4835 115.42 39.6198 116.116 39.6198C116.782 39.6198 117.418 39.4985 118.024 39.2564C118.629 39.0141 119.159 38.6813 119.613 38.2574C120.098 37.8334 120.476 37.3188 120.749 36.7133C121.021 36.1078 121.157 35.4568 121.157 34.7605V23.1804C121.157 23.1441 121.285 23.1804 121.987 23.1804C122.967 23.1804 123.275 23.2107 124.093 23.1804C124.91 23.1804 125.049 23.1804 126.114 23.1804C127.034 23.1804 127.152 23.1804 127.152 23.1804V34.5335C127.152 36.0472 126.864 37.4701 126.289 38.8023C125.714 40.1344 124.926 41.3 123.927 42.299C122.928 43.298 121.763 44.0852 120.431 44.6606C119.099 45.2357 117.66 45.5233 116.116 45.5233C114.663 45.5838 113.271 45.3418 111.938 44.7966C110.606 44.2215 109.426 43.4495 108.396 42.4808C107.397 41.4815 106.595 40.3312 105.989 39.0294C105.384 37.6972 105.081 36.3046 105.081 34.8513V23.3014C105.853 23.3014 105.117 23.3014 105.974 23.3014C107.087 23.3014 106.845 23.3014 107.693 23.3014ZM132.735 45.2086C131.917 45.2086 131.573 45.2086 130.774 45.2086C130.096 45.2086 129.824 45.2449 129.824 45.1481V34.261C129.855 32.8078 130.157 31.4454 130.733 30.1738C131.338 28.872 132.125 27.7518 133.094 26.8133C134.093 25.8445 135.244 25.0876 136.545 24.5427C137.878 23.9674 139.118 23.6404 140.602 23.5798C140.602 23.5798 140.71 24.1971 140.814 24.9354C140.935 25.7947 140.964 26.0748 141.106 26.8477C141.239 27.574 141.251 27.6708 141.461 28.7964L141.558 29.4137L140.814 29.4927C140.118 29.5468 139.467 29.6289 138.862 29.9014C138.256 30.1436 137.726 30.4917 137.272 30.9458C136.818 31.4 136.455 31.9449 136.182 32.5807C135.91 33.1862 135.773 33.8523 135.773 34.5789V42.8439C135.773 43.6231 135.817 44.6398 135.773 45.2086C135.12 45.2449 134.32 45.2086 132.735 45.2086ZM163.322 33.4384C163.322 32.6106 163.159 31.8123 162.834 31.0436C162.523 30.2601 162.095 29.5727 161.548 28.9814C161.001 28.3753 160.358 27.8949 159.619 27.5401C158.894 27.1705 158.118 26.9857 157.29 26.9857C156.463 26.9857 155.679 27.1262 154.94 27.407C154.216 27.6879 153.58 28.1018 153.033 28.6488C152.501 29.1958 152.079 29.8758 151.769 30.6888C151.459 31.4871 151.303 32.4036 151.303 33.4384C151.303 34.4288 151.459 35.3232 151.769 36.1215C152.079 36.905 152.501 37.5776 153.033 38.1393C153.58 38.7011 154.216 39.1371 154.94 39.4476C155.679 39.7432 156.463 39.8911 157.29 39.8911C158.118 39.8911 158.894 39.7137 159.619 39.3588C160.358 38.9894 161.001 38.5089 161.548 37.9176C162.095 37.3115 162.523 36.6241 162.834 35.8554C163.159 35.0719 163.322 34.2662 163.322 33.4384ZM169.42 42.5299C169.42 44.2002 169.102 45.7673 168.466 47.2306C167.831 48.6942 166.958 49.973 165.85 51.0669C164.756 52.1608 163.47 53.0255 161.991 53.6612C160.528 54.2968 158.961 54.6147 157.29 54.6147L154.252 54.5704V48.5167L157.246 48.5613C158.192 48.5613 158.998 48.4356 159.663 48.1841C160.328 47.9476 160.89 47.615 161.348 47.1863C161.806 46.7724 162.169 46.2921 162.435 45.7451C162.716 45.198 162.937 44.6216 163.1 44.0155C162.864 44.3999 162.523 44.7177 162.08 44.969C161.637 45.2055 161.141 45.3977 160.594 45.5456C160.062 45.708 159.501 45.8189 158.909 45.8782C158.333 45.9373 157.793 45.9668 157.29 45.9668C155.62 45.9668 154.046 45.6785 152.567 45.1021C151.104 44.5255 149.818 43.7051 148.709 42.6408C147.615 41.5616 146.75 40.246 146.115 38.6936C145.479 37.1415 145.161 35.3897 145.161 33.4384C145.161 31.6497 145.479 29.9866 146.115 28.4492C146.75 26.9118 147.615 25.5814 148.709 24.4579C149.818 23.3344 151.044 22.3879 152.507 21.7522C153.986 21.1166 154.335 21.0744 156.005 20.8081C156.84 20.7476 158.269 20.6599 159.14 20.7476C160.012 20.8354 160.314 20.8687 161.113 21.0744C161.912 21.2802 162.565 21.4382 163.322 21.8191C163.672 21.9955 164.044 22.2406 164.434 22.5203C165.388 23.2057 166.226 24.0391 166.971 24.9475C167.554 25.8984 167.945 26.9547 168.121 28.0563L168.466 30.2125L169.42 42.5299ZM197.004 33.4384C197.004 35.2123 196.687 36.868 196.051 38.4053C195.415 39.9282 194.55 41.2511 193.456 42.3745C192.363 43.4834 191.076 44.3628 189.598 45.0133C188.135 45.649 186.56 45.9668 184.875 45.9668C183.205 45.9668 181.63 45.649 180.152 45.0133C178.689 44.3628 177.402 43.4834 176.294 42.3745C175.2 41.2511 174.335 39.9282 173.699 38.4053C173.064 36.868 172.746 35.2123 172.746 33.4384C172.746 31.6349 173.064 29.9644 173.699 28.427C174.335 26.8896 175.2 25.5666 176.294 24.4579C177.402 23.3344 178.689 22.4548 180.152 21.8191C181.63 21.1835 183.205 20.8657 184.875 20.8657C186.56 20.8657 188.135 21.1687 189.598 21.7748C191.076 22.3661 192.363 23.2161 193.456 24.3248C194.55 25.4187 195.415 26.7418 196.051 28.294C196.687 29.8314 197.004 31.5462 197.004 33.4384ZM190.906 33.4384C190.906 32.4627 190.744 31.5832 190.419 30.7997C190.108 30.0014 189.679 29.3214 189.133 28.7597C188.586 28.1831 187.943 27.747 187.203 27.4514C186.479 27.1409 185.703 26.9857 184.875 26.9857C184.047 26.9857 183.264 27.1409 182.525 27.4514C181.8 27.747 181.165 28.1831 180.618 28.7597C180.086 29.3214 179.664 30.0014 179.354 30.7997C179.043 31.5832 178.888 32.4627 178.888 33.4384C178.888 34.3549 179.043 35.2049 179.354 35.9884C179.664 36.7719 180.086 37.4519 180.618 38.0284C181.165 38.605 181.8 39.0632 182.525 39.4033C183.264 39.7284 184.047 39.8911 184.875 39.8911C185.703 39.8911 186.479 39.7359 187.203 39.4254C187.943 39.115 188.586 38.6788 189.133 38.1172C189.679 37.5554 190.108 36.8754 190.419 36.0771C190.744 35.2789 190.906 34.3993 190.906 33.4384Z",
    fill: "url(#paint12_linear_3047_8368)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3047_8368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5665 54.8932V48.7953L55.937 48.8396C56.5283 48.8396 57.0975 48.7435 57.6444 48.5515C58.1914 48.3593 58.694 48.0931 59.1523 47.7532C59.6253 47.4131 60.0392 47.0067 60.394 46.5337C60.7488 46.0753 61.037 45.5727 61.2588 45.0257C60.5936 45.3066 59.9136 45.5875 59.2188 45.8683C58.5388 46.1492 57.8514 46.2896 57.1566 46.2896C55.6931 46.2896 54.3183 46.031 53.0322 45.5136C51.7461 44.9962 50.6152 44.2644 49.6395 43.3183C48.6787 42.3574 47.9173 41.197 47.3556 39.837C46.8086 38.4622 46.5352 36.9248 46.5352 35.2247V22.0977H52.5665V35.2247C52.5665 36.0674 52.6848 36.8065 52.9213 37.4422C53.1726 38.063 53.5052 38.5878 53.9191 39.0165C54.3331 39.4304 54.8135 39.7409 55.3605 39.9478C55.9222 40.1548 56.5209 40.2583 57.1566 40.2583C57.7774 40.2583 58.3614 40.1178 58.9083 39.837C59.4701 39.5413 59.9579 39.157 60.3718 38.6839C60.7858 38.2109 61.111 37.6787 61.3475 37.0874C61.584 36.4813 61.7023 35.8604 61.7023 35.2247V22.0977H67.8002V42.8527C67.7854 44.5231 67.4602 46.0901 66.8245 47.5535C66.1888 49.017 65.3167 50.2959 64.2079 51.3898C63.114 52.4837 61.8353 53.3484 60.3718 53.984C58.9083 54.6197 57.3414 54.9375 55.6709 54.9375L52.5665 54.8932Z",
    fill: "url(#paint13_linear_3047_8368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3047_8368",
    x1: 31.0598,
    y1: 85.006,
    x2: 68.4082,
    y2: 54.3882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544647,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3047_8368",
    x1: 35.9635,
    y1: 21.2526,
    x2: 7.08833,
    y2: 25.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544647,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3047_8368",
    x1: 10.1462,
    y1: 46.1781,
    x2: 11.2917,
    y2: 30.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B057DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3047_8368",
    x1: 8.13032,
    y1: 45.5694,
    x2: 20.1113,
    y2: 37.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D00B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3047_8368",
    x1: 1.84074e-7,
    y1: 43.2551,
    x2: 16.3532,
    y2: 41.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544647,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3047_8368",
    x1: 27.7893,
    y1: 4.80826e-7,
    x2: 23.5195,
    y2: 6.83393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF67A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3047_8368",
    x1: 4.08529,
    y1: 14.7133,
    x2: 8.71875,
    y2: 15.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF66A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3047_8368",
    x1: 5.33114,
    y1: 18.9847,
    x2: 6.30312,
    y2: 14.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E38CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3047_8368",
    x1: 5.50897,
    y1: 19.512,
    x2: 10.1533,
    y2: 16.3908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477264,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3047_8368",
    x1: 27.7893,
    y1: 4.80826e-7,
    x2: 23.5195,
    y2: 6.83393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF67A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3047_8368",
    x1: 25.8825,
    y1: 8.85912,
    x2: 27.3404,
    y2: 2.59233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3047_8368",
    x1: 26.1492,
    y1: 9.65011,
    x2: 33.1158,
    y2: 4.96834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477264,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3047_8368",
    x1: 76.6142,
    y1: 32.3542,
    x2: 199.379,
    y2: 33.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08BFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3047_8368",
    x1: 46.7515,
    y1: 29.3139,
    x2: 70.1503,
    y2: 29.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6535F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6FFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3047_8368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.671,
    height: 40.9095,
    fill: "white",
    transform: "translate(76.3281 13.7148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3047_8368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2778,
    height: 32.8729,
    fill: "white",
    transform: "translate(46.5254 22.0747)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBurgoLogo);
export default __webpack_public_path__ + "static/media/MyBurgo_logo.a23198e809d42bb788f6157324c6cb8d.svg";
export { ForwardRef as ReactComponent };